<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
            <div class="error-wrapper">
                <img class="error-img" :src="info.url" @click.stop="closeExchangePrizeFailure" />
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: 'exchangePrizeFailure',

    props: {

        info: {
			type: Object,
            required: true,
            default: () => {
                return {}
            }
		},

    },

    data() {
        return {

        }
    },
    
    mounted() {

    },

    methods: {
        closeExchangePrizeFailure() { // 关闭兑换奖品出现错误
            this.$emit('emitEvent', {
                type: 'closeExchangePrizeFailure',
                data: null,
                options: null
            })
        }
    }
}

</script>

<style lang="scss" scoped>

.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-wrapper {
    position: relative;
}

.error-img {
    width: 618px;
}

</style>